import {
  CompaniesSection,
  FeaturesSection,
  Footer,
  HeaderSection,
  PricingSection,
} from 'src/Sections';

const HomePage = () => {
  return (
    <>
      <HeaderSection />
      <CompaniesSection />
      <FeaturesSection />
      <PricingSection />
      <Footer />
    </>
  );
};

export { HomePage };
